import React, { useContext } from 'react'
import { PanelStyleContext } from '../../../../elem/panel/PanelStyleContext'
import { DataContext } from '../DataContext'

const ChartTabs = () => {
    const {
        visibleChartTab,
        setVisibleChartTab,
        toggleAnalyteWindowDropdown,
        toggleMeasureWindowDropdown,
        toggleGroupingWindowDropdown,
        toggleAnalyteResetExpanded,
    } = useContext(DataContext)
    const { tabClass } = useContext(PanelStyleContext)
    return (
        <div
            className={`tabs is-small is-boxed is-fullwidth ${tabClass} chartTabs`}
        >
            <ul>
                <li
                    className={
                        visibleChartTab === 'sampleResult' ? 'is-active' : ''
                    }
                    onClick={() => {
                        setVisibleChartTab('sampleResult')
                        toggleMeasureWindowDropdown(false)
                        toggleGroupingWindowDropdown(false)
                    }}
                >
                    <div>
                        <span>Sample Results</span>
                    </div>
                </li>
                <li
                    className={
                        visibleChartTab === 'pressure' ? 'is-active' : ''
                    }
                    onClick={() => {
                        // when we toggle pressure chart, hide dropdowns if they are displayed
                        setVisibleChartTab('pressure')
                        toggleAnalyteWindowDropdown(false)
                        toggleAnalyteResetExpanded(false)
                    }}
                >
                    <div>
                        <span>Pressure-Volume</span>
                    </div>
                </li>
            </ul>
        </div>
    )
}

export default ChartTabs
